import type {
  GetProduct1Data,
  GetProductData,
  ProductExpectedAmountResponse,
} from '~/api-spec/__generated__/pod'
import { parseApiResponse } from '~/schema/apiBoundary'
import { type Slice, sliceSchema } from '~/schema/slice'

import {
  type KmmProduct,
  KmmProductSchema,
  type PrintDocumentExpectedAmount,
  PrintDocumentExpectedAmountSchema,
  type PrintDocumentProduct,
  PrintDocumentProductSchema,
  type SignatureWorkbookProduct,
  type SignatureWorkbookProductDetail,
  SignatureWorkbookProductDetailSchema,
  SignatureWorkbookProductSchema,
} from './schemas'

const ENTITY = 'PodProduct'

// 생성 타입과 실제 와이어가 어긋나는 필드. 2026-10-06 POD 서버 develop(edfdcec) 코드로 확인:
//   KMM 시상품 — 서버 ProductResponse·ProductDetailResponse 의 @Schema(oneOf) 가 KmmAwardsProductResponse 를
//     빠뜨려 생성 타입에 KMM 변형이 없다(product/controller/response/ProductResponse.kt:16)
//   Slice 의 content·first·last 등 — 생성 타입은 optional 로 그리지만 SliceImpl 은 항상 싣는다
// 스키마가 실제 와이어를 검증하므로 입력을 이 한 자리에서 unknown 으로 넘긴다.
const asWire = (raw: GetProductData | GetProduct1Data): unknown => raw

export const adaptSignatureWorkbookProducts = (
  raw: GetProductData,
): Slice<SignatureWorkbookProduct> =>
  parseApiResponse(sliceSchema(SignatureWorkbookProductSchema), asWire(raw), ENTITY)

export const adaptPrintDocumentProducts = (raw: GetProductData): Slice<PrintDocumentProduct> =>
  parseApiResponse(sliceSchema(PrintDocumentProductSchema), asWire(raw), ENTITY)

export const adaptKmmProducts = (raw: GetProductData): Slice<KmmProduct> =>
  parseApiResponse(sliceSchema(KmmProductSchema), asWire(raw), ENTITY)

export const adaptSignatureWorkbookProductDetail = (
  raw: GetProduct1Data,
): SignatureWorkbookProductDetail =>
  parseApiResponse(SignatureWorkbookProductDetailSchema, asWire(raw), ENTITY)

export const adaptPrintDocumentExpectedAmount = (
  raw: ProductExpectedAmountResponse,
): PrintDocumentExpectedAmount => parseApiResponse(PrintDocumentExpectedAmountSchema, raw, ENTITY)
